import {useState} from "react";
import {ContentCopy, Link, OpenInNew, Visibility} from "@mui/icons-material";
import {Button, DialogActions, DialogContent, Grid, IconButton, Tooltip} from "@mui/material";
import copy from "copy-to-clipboard";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useLocation, useSearchParams} from "react-router-dom";
import {showMessage, SNACKBAR_MESSAGE_SEVERITY_SUCCESS} from "../../hocs/snackbar-provider";
import CustomDialog from "../custom-dialog";
import CustomDialogTitle from "../custom-dialog-title";
import {externalServicesSelector} from "../../state/config/configSelectors";
import {CATALOG_RESOURCE_TYPE_ODATA} from "../../utils/catalog";
import {getOdataUrl} from "../../utils/odata";

const OdataUrlViewer = ({resource, enableButtons}) => {
  const {t} = useTranslation();
  const location = useLocation();

  const [isODataUrlVisible, setODataUrlVisibility] = useState(false);

  const handleOpen = () => setODataUrlVisibility(true);
  const handleClose = () => setODataUrlVisibility(false);

  const baseurlFromConfig = useSelector(externalServicesSelector)?.odata;
  const [baseurl] = useState(resource.baseurl || baseurlFromConfig || null);

  const [, setSearchParams] = useSearchParams();

  return (
    <>
      <Tooltip title={t("modules.resourceHandlerOdata.header.oDataUrl.title")}>
        <IconButton onClick={handleOpen}>
          <Link />
        </IconButton>
      </Tooltip>
      <CustomDialog open={isODataUrlVisible} onClose={handleClose}>
        <CustomDialogTitle onClose={handleClose}>
          {t("modules.resourceHandlerOdata.header.oDataUrlDialog.title")}
        </CustomDialogTitle>
        <DialogContent>
          <Grid container wrap="nowrap" columnGap="8px">
            <Grid
              id="resouce-handler-odata__header__actions__url-container"
              sx={{
                overflowWrap: "break-word",
                wordBreak: "break-all",
                display: "flex",
                alignItems: "center",
                marginRight: "auto"
              }}
            >
              {getOdataUrl(baseurl, resource.datasource)}
            </Grid>
            <Grid
              sx={{
                display: "flex",
                alignItems: "center"
              }}
            >
              <IconButton
                onClick={() => {
                  copy(getOdataUrl(baseurl, resource.datasource));
                  showMessage(
                    t("modules.resourceHandlerOdata.header.oDataUrlDialog.copied"),
                    SNACKBAR_MESSAGE_SEVERITY_SUCCESS
                  );
                }}
              >
                <ContentCopy />
              </IconButton>
            </Grid>
            {enableButtons && (
              <>
                <Grid
                  id="data-viewer__odata__url-open-internal-btn"
                  sx={{
                    display: "none",
                    alignItems: "center"
                  }}
                >
                  <IconButton
                    onClick={() => {
                      const params = new URLSearchParams(location.search);
                      params.set("type", CATALOG_RESOURCE_TYPE_ODATA);
                      setSearchParams(params);
                    }}
                  >
                    <Visibility />
                  </IconButton>
                </Grid>
                <Grid
                  id="data-viewer__odata__url-open-external-btn"
                  sx={{
                    display: "none",
                    alignItems: "center"
                  }}
                >
                  <IconButton
                    onClick={() => {
                      const params = new URLSearchParams(location.search);
                      params.set("type", CATALOG_RESOURCE_TYPE_ODATA);
                      window.open(window.location.origin + window.location.pathname + "?" + params.toString());
                    }}
                  >
                    <OpenInNew />
                  </IconButton>
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("commons.confirm.close")}</Button>
        </DialogActions>
      </CustomDialog>
    </>
  );
};

export default OdataUrlViewer;
